import { SignalVerdict } from './signal'

export type FinalVerdict = {
  name: SignalVerdict
  threatLevel: number
  confidence: number
}

export const threatVerdicts = [SignalVerdict.Malicious, SignalVerdict.Likely_malicious, SignalVerdict.Suspicious]
